export function createImgSrcset(imgPath, sizes) {
  return sizes
    .map((size) => {
      return `${imgPath}&width=${size} ${size}w`;
    })
    .join(', ');
}
